import { Link } from "react-router-dom";

interface ContextBarProps {
  /** Toggle the slide-in. Drive from useScrollPastHero(). */
  visible: boolean;
  /** Small mono badge on the left — e.g. "B.E. · CSE", "FACULTY · F01", "CLASS OF 1986". */
  tag?: string;
  /** Main name / title shown in the bar. */
  title: string;
  /** Optional "← Back to …" link on the right. Hidden on mobile. */
  back?: { label: string; to: string };
}

/**
 * Slim sticky bar that appears under the main header once the page's
 * primary hero scrolls past. Fixed-positioned, slides in via transform,
 * reserves no flow space when hidden. Used across detail pages to keep
 * the page identity visible during long scrolls.
 */
export function ContextBar({ visible, tag, title, back }: ContextBarProps) {
  return (
    <div
      className={"context-bar" + (visible ? " is-visible" : "")}
      aria-hidden={!visible}
    >
      <div className="container">
        <div className="cxb-left">
          {tag && (
            <>
              <span className="cxb-tag">{tag}</span>
              <span className="cxb-sep" aria-hidden>/</span>
            </>
          )}
          <span className="cxb-name">{title}</span>
        </div>
        {back && (
          <Link to={back.to} className="cxb-back">
            <span aria-hidden>←</span> {back.label}
          </Link>
        )}
      </div>
    </div>
  );
}
